import React from 'react';
import { Link } from 'react-router-dom';

const DocumentList = ({ companyDetails }) => {

    console.log(companyDetails);

    return (
        <>
            {(companyDetails) &&
                <div className=" w-full pb-10 pt-0">

                    <h1 className="font-bold text-lg mb-3 px-2">Uploaded Document List</h1>

                    <table className="custom-details-table w-full mt-0 mb-2">
                        <tbody>
                            <tr>
                                <td className="font-semibold text-base">Trade License</td>
                                {companyDetails?.trade_license && <td className="px-5 text-base"><Link target="_blank" rel='noopener' to={companyDetails.trade_license}>View</Link></td>}
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">TIN/BIN</td>
                                {companyDetails?.tin && <td className="px-5 text-base"><Link target="_blank" rel='noopener' to={companyDetails.tin}>View</Link> </td>}
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Incorporation</td>
                                {companyDetails?.incorporation && <td className="px-5 text-base"><Link target="_blank" rel='noopener' to={companyDetails.incorporation}>View</Link> </td>}
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Nid</td>
                                {companyDetails?.owner_nid && <td className="px-5 text-base"><Link target="_blank" rel='noopener' to={companyDetails.owner_nid}>View</Link> </td>}
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Visiting Card or Eid</td>
                                {companyDetails?.poc_visiting_card && <td className="px-5 text-base"><Link target="_blank" rel='noopener' to={companyDetails.poc_visiting_card}>View</Link> </td>}
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Registration Form</td>
                                {companyDetails?.registration_form && <td className="px-5 text-base"><Link target="_blank" rel='noopener' to={companyDetails.registration_form}>View</Link> </td>}
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Others</td>
                                {companyDetails?.other && <td className="px-5 text-base"><Link target="_blank" rel='noopener' to={companyDetails.other}>View</Link> </td>}
                            </tr>
                        </tbody>
                    </table>

                </div>}

                <style jsx={true}>{`
                table.custom-details-table tr td:first-child {
                    width: 300px;
                }
                `}</style>
        </>
    );
};

export default DocumentList;